<ng-container *ngIf="steps && sale && cart">
    <h2 class="flex align-center">Cart</h2>
    <div overflow>
        <ng-container *ngIf="cart.items as products">
            <app-product-card-alt
                *ngFor="let product of products"
                [descriptionMaxHeight]="50"
                [product]="product"
                [sale]="sale"
                [selected]="true"
                (toggle)="cart.toggle(product)"
            ></app-product-card-alt>
        </ng-container>

        <p class="sticky-bottom cost-of-borrow m-0 pt-4 lvl-1 pb-0" *ngIf="sale.payment_type === 'finance'">
            See Summary page for total cost of borrowing
        </p>

        <p class="sticky-bottom cost-of-borrow m-0 lvl-1 pb-2">
            Not Including Installation
        </p>
    </div>
</ng-container>
